import { createContext, useState } from "react";

const MyContext = createContext();

const MyProvider = ({ children }) => {
  const predefined_entities = [
    "CREDIT_CARD",
    "ORG",
    "MONEY",
    "SSN",
    "DATE_TIME",
    "PERSON",
    "Phone_Number",
    "LOC",
    "FAC",
    "GPE",
    "NORP",
    "TIME",
    "ORDINAL",
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [docs, setDocs] = useState([]);
  const [processedFiles, setProcessedFiles] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [currentUserToEdit, setCurrentUserToEdit] = useState("");
  const [allowList, setAllowList] = useState([]);
  const [selectedEntities, setSelectedEntitites] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [searchText, setSearchText] = useState([]);
  const [saveTerms, setSaveTerms] = useState([]);
  const [savePara, setSavePara] = useState([]);


  const [checkedState, setCheckedState] = useState(
    predefined_entities.reduce((acc, entity) => {
      acc[entity] = false;
      return acc;
    }, {})
  );
  const [reductionType, setReductionType] = useState("highlight");
  const [findingsWithHighlight, setFindingsWithHighlight] = useState([]);

  const toggleHighlight = (id) => {
    setFindingsWithHighlight((prevFindings) =>
      prevFindings.map((finding) =>
        finding.id === id
          ? { ...finding, highlight: !finding.highlight }
          : finding
      )
    );
  };

  const value = {
    predefined_entities,
    docs,
    setDocs,
    currentUserToEdit,
    setCurrentUserToEdit,
    processedFiles,
    setProcessedFiles,
    isLoading,
    setIsLoading,
    allowList,
    setAllowList,
    selectedEntities,
    setSelectedEntitites,
    selectedDocs,
    setSelectedDocs,
    selectedFiles,
    setSelectedFiles,
    searchText,
    setSearchText,
    saveTerms,
    setSaveTerms,
    savePara,
    setSavePara,
    checkedState,
    setCheckedState,
    reductionType,
    setReductionType,
    findingsWithHighlight,
    setFindingsWithHighlight,
    toggleHighlight,
  };

  return <MyContext.Provider value={value}>{children}</MyContext.Provider>;
};

export { MyContext, MyProvider };
